angular
  .module 'filters'
  .filter 'eventTime', ->
    (event) ->
      start = moment(event.start, 'YYYY/MM/DD HH:mm').format('h:mma')
      end = moment(event.end, 'YYYY/MM/DD HH:mm').format('h:mma')
      "#{start} - #{end}"
